module.exports = __webpack_public_path__ + "img/04506303000131.46e53608.png";